<script setup lang="ts">
import { useOAuthApi } from '../../api/oauth/get.hook'
import OAuthConnections from './OAuthConnections.vue'

defineOptions({
  name: 'OAuthPage',
})

onMounted(() => {
  void useOAuthApi()
})
</script>

<template>
  <OAuthConnections />
</template>
